import { SVGProps } from "react";

export const TwoFactorAuth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.08714 9.12988C7.00714 9.12988 6.46714 9.90988 6.34714 10.3899C6.22714 10.8699 6.22714 12.6099 6.29914 13.3299C6.53914 14.2299 7.13914 14.6019 7.72714 14.7219C8.26714 14.7699 10.5471 14.7519 11.2071 14.7519C12.1671 14.7699 12.8871 14.4099 13.1871 13.3299C13.2471 12.9699 13.3071 10.9899 13.1571 10.3899C12.8391 9.42988 12.0471 9.12988 11.4471 9.12988H8.08714Z"
      stroke={props.color || "#1A1C1F"}
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M8 8.70854C8 8.64854 8.00822 8.30312 8.0096 7.86854C8.01086 7.47145 7.976 7.08854 8.1656 6.73814C8.876 5.32454 10.916 5.46854 11.42 6.90854C11.5073 7.14562 11.5126 7.52146 11.51 7.86854C11.5067 8.31203 11.516 8.70854 11.516 8.70854"
      stroke={props.color || "#1A1C1F"}
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M18.75 9.93334V7.03029C18.75 5.39029 18.75 4.57028 18.3459 4.03529C17.9418 3.50029 17.0281 3.24056 15.2007 2.7211C13.9522 2.3662 12.8516 1.93863 11.9723 1.54829C10.7734 1.0161 10.174 0.75 9.75 0.75C9.32604 0.75 8.7266 1.0161 7.52771 1.54829C6.64839 1.93863 5.54784 2.36619 4.29933 2.7211C2.47193 3.24056 1.55822 3.50029 1.15411 4.03529C0.75 4.57028 0.75 5.39029 0.75 7.03029V9.93334C0.75 15.5585 5.81277 18.9335 8.34395 20.2694C8.95106 20.5898 9.25462 20.75 9.75 20.75C10.2454 20.75 10.5489 20.5898 11.156 20.2694C13.6872 18.9335 18.75 15.5585 18.75 9.93334Z"
      stroke={props.color || "#1A1C1F"}
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
